module.exports = __webpack_public_path__ + "assets/img/tik-tok.1bd9e8c1.svg";